import { FComponent } from 'Components/f-component';

export class ViewModel extends FComponent {
  constructor(params, element) {
    super(params, element);
    element.classList.add('fc-opener');
    this.open = params.open;
  }
}
